import { createVNode as _createVNode } from "vue";
import { defineComponent, ref, watch } from "vue";
import TeamInfoPopup from "@/components/common/team-info-popup";
import Item from "./item.vue";
export default defineComponent({
  name: "BattleList",
  props: {
    gameData: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    }
  },
  setup(props) {
    watch(() => props.gameData, () => {
      const listObj = document.getElementsByClassName("battle-list");
      listObj[0].scrollTop = 0;
    }, {
      deep: true
    });
    const visible = ref(false);
    const currentTeam = ref({});
    const handleShowPopup = teamInfo => {
      currentTeam.value = teamInfo;
      visible.value = true;
    };
    const handleClosePopup = () => {
      visible.value = false;
    };
    return () => {
      var _props$gameData;
      return _createVNode("div", {
        "class": "battle-list"
      }, [(_props$gameData = props.gameData) === null || _props$gameData === void 0 ? void 0 : _props$gameData.map(item => {
        return _createVNode(Item, {
          "key": item.id,
          "battleData": item,
          "onSelectTeam": handleShowPopup
        }, null);
      }), _createVNode(TeamInfoPopup, {
        "visible": visible.value,
        "teamInfo": currentTeam.value,
        "onClose": handleClosePopup
      }, null)]);
    };
  }
});